// src/components/About.jsx
import React from "react";

export default function About() {
  return (
    <section
      className="mt-4 text-gray-300 space-y-4 leading-relaxed text-sm"
      aria-labelledby="about-dat-heading"
    >
      <h2
        id="about-dat-heading"
        className="text-lg font-bold text-gray-100 mb-2"
      >
        What is Dialectical Analysis Theory (DAT)?
      </h2>

      <p>
        <strong>Dialectical Analysis Theory</strong> is a reasoning engine
        designed to reveal and clarify assumptions. DAT systematically uncovers
        contradictions and incomplete knowledge by interrogating the epistemic
        logic underlying every question. It transforms hidden tensions into
        explicit, testable, and accountable structures for analysis.
      </p>
      <p>
        Every question—whether simple arithmetic or philosophical paradox—is
        processed through four disciplined stages: contradiction validation,
        synthesis testing, structural transformation, and structured resolution.
        DAT demands ontological clarity, precise epistemic categorisation, and
        full structural mapping at every step.
      </p>
      <p>
        <strong>DAT analyses without shortcuts.</strong> It examines every
        assumption, ensures no contradiction is overlooked, and avoids premature
        closure by fully mapping the underlying logic.
      </p>
      <p>
        Through careful analysis, DAT disciplines arguments, clarifies claims,
        and evaluates lines of inquiry across mathematical, empirical, symbolic,
        and phenomenological domains.
      </p>
      <p>
        In an era dominated by cognitive shortcuts, DAT provides a new approach:
        It retools large language models to reason dialectically, producing
        outputs that are traceable, structured, and defensible.
      </p>
      <p>
        Whether exploring causality, consciousness, ethics, or the limits of
        logic, DAT identifies the precise conditions under which an argument
        holds—and when it must be revised.
      </p>
    </section>
  );
}
